// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2gI2j","errorLogs":"EditorFooter_errorLogs__1uWYW"};